import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.solutions');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-solutions',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.solutions/view.scss */
:host {
  display: block;
  background: #FFFFFF;
}

:host *,
:host *::before,
:host *::after {
  animation: none !important;
  transition: none !important;
  scroll-behavior: auto !important;
}

.solution-page {
  min-height: 60vh;
  background: #FFFFFF;
  overflow-x: clip;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.solution-page h2,
.solution-page h3,
.solution-page h4 {
  text-wrap: balance;
  word-break: keep-all;
  overflow-wrap: normal;
}

.solution-page p,
.solution-page span,
.solution-page button {
  word-break: keep-all;
  overflow-wrap: break-word;
  text-wrap: pretty;
}

.solution-tabs-wrap {
  position: sticky;
  top: 0;
  z-index: 30;
  background: rgba(250, 250, 250, 0.96);
  border-bottom: 1px solid #E4E4E7;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.solution-tabs {
  display: flex;
  align-items: center;
  gap: 6px;
  overflow-x: auto;
  padding: 10px 0;
  scrollbar-width: none;
}
.solution-tabs::-webkit-scrollbar {
  display: none;
}

.solution-tab {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #71717A;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}
.solution-tab span {
  white-space: nowrap;
  word-break: normal;
  overflow-wrap: normal;
  text-wrap: nowrap;
  line-height: 1.2;
}
.solution-tab i,
.solution-tab img {
  flex: 0 0 auto;
  line-height: 1;
}
.solution-tab:hover {
  background: #FFFFFF;
  color: #18181B;
}
.solution-tab.active {
  background: #FFFFFF;
  border-color: #FED7CC;
  color: #FE5A33;
  box-shadow: 0 1px 2px rgba(24, 24, 27, 0.04);
}

.solution-tab-logo {
  display: block;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  border-radius: 5px;
  object-fit: contain;
}

.solution-overview,
.solution-detail {
  background: #FFFFFF;
}

.solution-detail {
  background: #F4F4F5;
}

.solution-detail-stack {
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.solution-detail-stack > .detail-hero {
  padding: 40px;
  border: 1px solid rgba(254, 90, 51, 0.18);
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(254, 90, 51, 0.28), rgba(254, 90, 51, 0.08) 42%, rgba(255, 255, 255, 0) 100%), linear-gradient(135deg, #232326 0%, #302A27 54%, #4A332D 100%);
  color: #FFFFFF;
  box-shadow: 0 24px 54px rgba(24, 24, 27, 0.16);
}

.solution-detail-stack > .detail-hero::before {
  content: none;
}

.solution-detail-stack > .detail-tags {
  margin-bottom: 0;
}

.solution-detail-stack .section-heading,
.solution-detail-stack .works-section-heading,
.solution-detail-stack .reviewops-section-heading,
.solution-detail-stack .wiz-section-heading,
.solution-detail-stack .dizest-section-heading {
  margin-bottom: 26px;
  padding-bottom: 18px;
  border-bottom: 1px solid #E4E4E7;
}

.section-kicker {
  margin-bottom: 14px;
  color: #FE5A33;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0;
}

.solution-direction-section {
  padding: 32px 0 72px;
  background: #F4F4F5;
}

.solution-list-section {
  padding: 72px 0 84px;
  border-top: 1px solid #E4E4E7;
  background: #FAFAFA;
}

.direction-panel {
  margin-bottom: 18px;
  padding: 44px;
  border-radius: 8px;
  background: linear-gradient(135deg, #18181B 0%, #232326 100%);
  box-shadow: 0 18px 44px rgba(24, 24, 27, 0.12);
}

.direction-heading {
  display: grid;
  grid-template-columns: minmax(0, 0.86fr) minmax(0, 1.14fr);
  gap: 36px;
  align-items: start;
  margin-bottom: 24px;
}

.direction-heading h2,
.solution-list-heading h2 {
  margin: 0 0 18px;
  color: #09090B;
  font-size: clamp(30px, 3.6vw, 46px);
  font-weight: 800;
  line-height: 1.08;
}

.direction-panel .direction-heading h2 {
  max-width: 620px;
  margin-bottom: 0;
  color: #FFFFFF;
  font-size: clamp(32px, 3.8vw, 48px);
}

.direction-heading-copy {
  align-self: end;
  max-width: 660px;
  padding-bottom: 2px;
}

.direction-heading p:not(.section-kicker),
.solution-list-heading p {
  color: #52525B;
  font-size: 16px;
  line-height: 1.72;
}

.direction-panel .direction-heading p {
  color: rgba(255, 255, 255, 0.74);
}

.direction-panel .direction-heading-copy p {
  margin: 0;
  color: rgba(255, 255, 255, 0.76);
  font-size: 16px;
  line-height: 1.56;
}

.direction-heading p + p {
  margin-top: 12px;
}

.direction-heading-copy p + p {
  margin-top: 8px;
}

.direction-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  margin-bottom: 18px;
  padding: 0 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.2;
  white-space: nowrap;
  word-break: keep-all;
  overflow-wrap: normal;
}

.direction-highlight-grid {
  display: grid;
  grid-template-columns: 1.14fr 0.93fr 0.93fr;
  gap: 14px;
  margin-bottom: 0;
}

.direction-highlight-card {
  min-height: 172px;
  padding: 22px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.07);
}
.direction-highlight-card strong {
  display: block;
  color: #FFFFFF;
  font-size: 32px;
  font-weight: 900;
  line-height: 1;
}
.direction-highlight-card h3 {
  margin: 18px 0 10px;
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 900;
}
.direction-highlight-card p {
  color: rgba(255, 255, 255, 0.68);
  font-size: 16px;
  line-height: 1.62;
}
.direction-highlight-card.is-primary {
  border-color: rgba(254, 90, 51, 0.58);
  background: rgba(254, 90, 51, 0.14);
}
.direction-highlight-card.is-primary strong {
  color: #FE5A33;
}
.direction-highlight-card.is-primary h3 {
  color: #FFFFFF;
}
.direction-highlight-card.is-primary p {
  color: rgba(255, 255, 255, 0.82);
}

.direction-flow-strip {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 1px;
  overflow: hidden;
  margin-bottom: 18px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #E4E4E7;
}

.direction-flow-item {
  min-height: 154px;
  padding: 20px;
  background: #FFFFFF;
  box-shadow: inset 0 4px 0 #D4D4D8;
}
.direction-flow-item h3 {
  margin: 16px 0 8px;
  color: #18181B;
  font-size: 16px;
  font-weight: 800;
}
.direction-flow-item p {
  color: #71717A;
  font-size: 16px;
  line-height: 1.58;
}

.direction-step-index {
  color: #FE5A33;
  font-size: 16px;
  font-weight: 900;
}

.direction-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 18px;
}

.direction-card {
  min-height: 166px;
  padding: 20px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FAFAFA;
}
.direction-card h3 {
  margin: 12px 0 8px;
  color: #18181B;
  font-size: 16px;
  font-weight: 800;
}
.direction-card p {
  color: #71717A;
  font-size: 16px;
  line-height: 1.62;
}

.direction-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
  color: #3F3F46;
  box-shadow: 0 1px 2px rgba(24, 24, 27, 0.06);
}

.visual-label {
  display: flex;
  align-items: center;
  gap: 8px;
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 12px;
  min-height: 40px;
  padding: 9px 12px;
  border-radius: 8px;
  background: rgba(9, 9, 11, 0.78);
  color: #FFFFFF;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}
.visual-label .solution-card-logo {
  display: block;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border-radius: 5px;
  object-fit: contain;
}
.visual-label strong {
  flex-shrink: 0;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.2;
  white-space: nowrap;
}
.visual-label span {
  min-width: 0;
  overflow: hidden;
  color: rgba(255, 255, 255, 0.82);
  font-size: 16px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;
}

.solution-list-heading {
  max-width: 760px;
  margin-bottom: 30px;
}
.solution-list-heading h2 {
  margin-bottom: 14px;
}
.solution-list-heading p {
  max-width: 640px;
}

.solution-card-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 16px;
}

.solution-card {
  display: flex;
  min-height: 438px;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}
.solution-card:hover {
  border-color: #FED7CC;
  box-shadow: 0 18px 40px rgba(24, 24, 27, 0.1);
  transform: translateY(-2px);
}

.solution-card-visual {
  position: relative;
  height: 170px;
  overflow: hidden;
  background: #F4F4F5;
  border-bottom: 1px solid #E4E4E7;
}
.solution-card-visual > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top left;
  transition: transform 0.35s ease;
}
.solution-card:hover .solution-card-visual > img {
  transform: scale(1.04);
}

.visual-label {
  left: 10px;
  right: 10px;
  bottom: 10px;
  min-height: 36px;
  color: #FFFFFF;
}
.visual-label i {
  flex-shrink: 0;
  color: #FFFFFF;
}

.solution-card-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 18px;
}

.solution-card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
  color: #18181B;
}
.solution-card-title h3 {
  font-size: 18px;
  font-weight: 800;
}
.solution-card-title i {
  color: #A1A1AA;
  transition: color 0.2s ease;
}
.solution-card:hover .solution-card-title i {
  color: #FE5A33;
}

.solution-card-tagline {
  color: #3F3F46;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.55;
}

.solution-card-direction {
  margin-top: 10px;
  color: #71717A;
  font-size: 16px;
  line-height: 1.62;
}

.solution-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 7px 12px;
  margin-top: auto;
  padding-top: 16px;
}
.solution-card-tags span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0;
  background: transparent;
  color: #71717A;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.35;
  white-space: nowrap;
  word-break: keep-all;
  overflow-wrap: normal;
}
.solution-card-tags span::before {
  content: "#";
  color: #FE5A33;
  font-weight: 900;
}

.detail-hero {
  display: grid;
  grid-template-columns: minmax(0, 0.94fr) minmax(0, 1.06fr);
  gap: 36px;
  align-items: start;
  margin-bottom: 0;
  overflow: hidden;
  padding: 40px;
  border: 1px solid rgba(254, 90, 51, 0.18);
  border-radius: 10px;
  background-color: #232326;
  background-image: linear-gradient(135deg, rgba(254, 90, 51, 0.28), rgba(254, 90, 51, 0.08) 42%, rgba(255, 255, 255, 0) 100%), linear-gradient(135deg, #232326 0%, #302A27 54%, #4A332D 100%);
  color: #FFFFFF;
  box-shadow: 0 24px 54px rgba(24, 24, 27, 0.16);
}

.solution-detail-hero-panel,
.solution-detail .detail-hero,
.solution-detail .solution-detail-stack > :first-child {
  display: grid;
  grid-template-columns: minmax(0, 0.94fr) minmax(0, 1.06fr);
  gap: 36px;
  align-items: start;
  overflow: hidden;
  padding: 40px;
  border: 1px solid rgba(254, 90, 51, 0.18);
  border-radius: 10px;
  background-color: #232326 !important;
  background-image: linear-gradient(135deg, rgba(254, 90, 51, 0.28), rgba(254, 90, 51, 0.08) 42%, rgba(255, 255, 255, 0) 100%), linear-gradient(135deg, #232326 0%, #302A27 54%, #4A332D 100%) !important;
  color: #FFFFFF;
  box-shadow: 0 24px 54px rgba(24, 24, 27, 0.16);
}

.detail-copy {
  max-width: 680px;
}

.detail-hero .section-kicker {
  color: #FFD7CC;
}

.detail-title-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.detail-icon-tile {
  display: flex;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.18);
  color: #FFFFFF;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.24);
}
.detail-icon-tile i {
  color: #FFFFFF;
}

.solution-logo-mark {
  display: block;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  object-fit: contain;
}

.detail-hero h2,
.detail-hero h3,
.detail-hero .detail-title-row p,
.detail-hero .detail-copy > p:not(.section-kicker) {
  color: #FFFFFF;
}

.detail-hero .detail-title-row p {
  color: rgba(255, 255, 255, 0.74);
}

.direction-callout {
  display: flex;
  gap: 12px;
  padding: 16px;
  border: 1px solid #FED7CC;
  border-radius: 8px;
  background: #FFF7F4;
  color: #FE5A33;
}
.direction-callout i {
  flex-shrink: 0;
  margin-top: 2px;
}
.direction-callout p {
  color: #52525B;
  font-size: 16px;
  line-height: 1.65;
}

.detail-hero .direction-callout {
  border-color: rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.15);
  color: #FFFFFF;
}
.detail-hero .direction-callout p {
  color: rgba(255, 255, 255, 0.88);
}

.detail-process-panel {
  display: grid;
  gap: 18px;
  min-height: 320px;
  align-content: center;
  padding: 28px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FAFAFA;
}

.detail-hero .detail-process-panel {
  border-color: rgba(255, 255, 255, 0.62);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 18px 42px rgba(126, 37, 17, 0.16);
}

.works-hero-visual {
  position: relative;
  overflow: hidden;
  min-height: 320px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #F4F4F5;
  box-shadow: 0 18px 40px rgba(24, 24, 27, 0.08);
}
.works-hero-visual img {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 320px;
  object-fit: cover;
  object-position: center;
}

.works-hero-caption {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 16px;
  display: flex;
  min-height: 44px;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(9, 9, 11, 0.78);
  color: #FFFFFF;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}
.works-hero-caption i {
  flex-shrink: 0;
}
.works-hero-caption span {
  min-width: 0;
  overflow: hidden;
  font-size: 16px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reviewops-hero-visual {
  position: relative;
  overflow: hidden;
  min-height: 320px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #F4F4F5;
  box-shadow: 0 18px 40px rgba(24, 24, 27, 0.08);
}
.reviewops-hero-visual img {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 320px;
  object-fit: cover;
  object-position: left top;
}

.reviewops-hero-caption {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 16px;
  z-index: 2;
  display: flex;
  min-height: 44px;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(9, 9, 11, 0.78);
  color: #FFFFFF;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}
.reviewops-hero-caption i {
  flex-shrink: 0;
}
.reviewops-hero-caption span {
  min-width: 0;
  overflow: hidden;
  font-size: 16px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reviewops-hero-markers {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
}
.reviewops-hero-markers span {
  position: absolute;
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  padding: 0 10px;
  border: 1px solid rgba(254, 90, 51, 0.36);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  color: #FE5A33;
  font-size: 16px;
  font-weight: 900;
  box-shadow: 0 10px 24px rgba(24, 24, 27, 0.12);
}
.reviewops-hero-markers .is-left {
  left: 18px;
  top: 86px;
}
.reviewops-hero-markers .is-right {
  right: 18px;
  top: 116px;
}
.reviewops-hero-markers .is-bottom {
  left: 38%;
  bottom: 74px;
}

.process-panel-heading h3 {
  color: #18181B;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.3;
}
.process-panel-heading p {
  margin-top: 8px;
  color: #71717A;
  font-size: 16px;
  line-height: 1.62;
}

.detail-flow {
  display: grid;
  grid-template-columns: 1fr 32px 1fr 32px 1fr;
  align-items: center;
  gap: 8px;
}

.flow-node {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 48px;
  padding: 0 12px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
  color: #3F3F46;
  font-size: 16px;
  font-weight: 800;
}
.flow-node.is-primary {
  border-color: #FED7CC;
  color: #FE5A33;
  background: #FFF7F4;
}

.flow-line {
  height: 1px;
  background: #D4D4D8;
}

.process-note-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.process-note {
  min-height: 96px;
  padding: 14px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
}
.process-note strong {
  display: block;
  color: #FE5A33;
  font-size: 16px;
  font-weight: 800;
  margin-bottom: 8px;
}
.process-note span {
  color: #52525B;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
}

.detail-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 9px 16px;
  margin-bottom: 12px;
  padding: 0 2px;
}
.detail-tags span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0;
  background: transparent;
  color: #71717A;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.45;
  white-space: nowrap;
  word-break: keep-all;
  overflow-wrap: normal;
}
.detail-tags span::before {
  content: "#";
  color: #FE5A33;
  font-size: 16px;
  font-weight: 900;
}

.section-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  color: #18181B;
  font-size: 16px;
  font-weight: 800;
}
.section-heading i {
  flex: 0 0 auto;
  line-height: 1;
}
.section-heading span {
  line-height: 1.2;
  word-break: keep-all;
  overflow-wrap: normal;
}

.feature-card {
  display: flex;
  gap: 16px;
  min-height: 148px;
  padding: 22px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FAFAFA;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.feature-card:hover {
  border-color: #FED7CC;
  background: #FFFFFF;
}

.feature-icon {
  display: flex;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
  color: #FE5A33;
}

.reviewops-section-heading,
.works-section-heading {
  max-width: 800px;
  margin-bottom: 24px;
}
.reviewops-section-heading h3,
.works-section-heading h3 {
  margin: 0 0 12px;
  color: #18181B;
  font-size: 28px;
  font-weight: 900;
  line-height: 1.2;
}
.reviewops-section-heading p:not(.section-kicker),
.works-section-heading p:not(.section-kicker) {
  color: #71717A;
  font-size: 16px;
  line-height: 1.72;
}

.reviewops-workflow-section {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  align-items: stretch;
}

.reviewops-screen-visual {
  position: relative;
  overflow: hidden;
  min-height: 430px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #F4F4F5;
}
.reviewops-screen-visual img {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 430px;
  object-fit: cover;
  object-position: left top;
}

.reviewops-screen-caption {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 16px;
  display: flex;
  min-height: 44px;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(9, 9, 11, 0.78);
  color: #FFFFFF;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}
.reviewops-screen-caption i {
  flex-shrink: 0;
}
.reviewops-screen-caption span {
  min-width: 0;
  overflow: hidden;
  font-size: 16px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reviewops-workflow-copy {
  padding: 28px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
}
.reviewops-workflow-copy h3 {
  margin: 0 0 12px;
  color: #18181B;
  font-size: 26px;
  font-weight: 900;
  line-height: 1.25;
}
.reviewops-workflow-copy > p:not(.section-kicker) {
  color: #71717A;
  font-size: 16px;
  line-height: 1.72;
}

.reviewops-flow-list {
  display: grid;
  gap: 10px;
  margin-top: 22px;
}

.reviewops-flow-step {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  column-gap: 14px;
  row-gap: 4px;
  min-height: 104px;
  padding: 16px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FAFAFA;
}
.reviewops-flow-step > div {
  grid-row: 1/span 2;
  display: flex;
  width: 48px;
  height: 48px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 8px;
  background: #FFF5F2;
  color: #FE5A33;
}
.reviewops-flow-step span {
  font-size: 16px;
  font-weight: 900;
  line-height: 1;
}
.reviewops-flow-step h4 {
  color: #18181B;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.35;
}
.reviewops-flow-step p {
  color: #71717A;
  font-size: 16px;
  line-height: 1.58;
}

.reviewops-contract-map {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.reviewops-contract-card {
  min-height: 190px;
  padding: 22px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FAFAFA;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}
.reviewops-contract-card:hover {
  border-color: #FED7CC;
  box-shadow: 0 16px 34px rgba(24, 24, 27, 0.08);
  transform: translateY(-2px);
}
.reviewops-contract-card.is-primary {
  background: #FFF7F4;
  border-color: #FED7CC;
}
.reviewops-contract-card > span {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  margin: 16px 0 14px;
  padding: 0 9px;
  border-radius: 6px;
  background: #FFF5F2;
  color: #FE5A33;
  font-size: 16px;
  font-weight: 900;
}
.reviewops-contract-card h4 {
  color: #18181B;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.35;
}
.reviewops-contract-card p {
  margin-top: 10px;
  color: #71717A;
  font-size: 16px;
  line-height: 1.62;
}

.reviewops-contract-icon,
.reviewops-data-card > i {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid #FED7CC;
  border-radius: 8px;
  background: #FFFFFF;
  color: #FE5A33;
}

.reviewops-signal-board {
  display: grid;
  grid-template-columns: minmax(0, 0.92fr) minmax(0, 1.08fr);
  gap: 18px;
}

.reviewops-signal-flow {
  display: grid;
  gap: 12px;
}
.reviewops-signal-flow article {
  position: relative;
  min-height: 116px;
  padding: 20px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
}
.reviewops-signal-flow article.is-focus {
  border-color: #FED7CC;
  background: #FFF7F4;
}
.reviewops-signal-flow span {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  padding: 0 9px;
  border-radius: 6px;
  background: #F4F4F5;
  color: #52525B;
  font-size: 16px;
  font-weight: 900;
}
.reviewops-signal-flow h4 {
  margin-top: 12px;
  color: #18181B;
  font-size: 17px;
  font-weight: 900;
  line-height: 1.35;
}
.reviewops-signal-flow p {
  margin-top: 8px;
  color: #71717A;
  font-size: 16px;
  line-height: 1.62;
}

.reviewops-data-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.reviewops-data-card {
  display: flex;
  gap: 14px;
  min-height: 116px;
  padding: 18px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FAFAFA;
}
.reviewops-data-card > i {
  flex-shrink: 0;
}
.reviewops-data-card h4 {
  color: #18181B;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.35;
}
.reviewops-data-card p {
  margin-top: 8px;
  color: #71717A;
  font-size: 16px;
  line-height: 1.6;
}

.works-workflow-section {
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(0, 0.92fr);
  gap: 28px;
  align-items: stretch;
}

.works-screen-visual {
  position: relative;
  overflow: hidden;
  min-height: 430px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #F4F4F5;
}
.works-screen-visual img {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 430px;
  object-fit: cover;
  object-position: center;
}

.works-screen-caption {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 16px;
  display: flex;
  min-height: 44px;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(9, 9, 11, 0.78);
  color: #FFFFFF;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}
.works-screen-caption i {
  flex-shrink: 0;
}
.works-screen-caption span {
  min-width: 0;
  overflow: hidden;
  font-size: 16px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.works-workflow-copy {
  padding: 28px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
}
.works-workflow-copy h3 {
  margin: 0 0 12px;
  color: #18181B;
  font-size: 26px;
  font-weight: 900;
  line-height: 1.25;
}
.works-workflow-copy > p:not(.section-kicker) {
  color: #71717A;
  font-size: 16px;
  line-height: 1.72;
}

.works-flow-list {
  display: grid;
  gap: 10px;
  margin-top: 22px;
}

.works-flow-step {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  column-gap: 14px;
  row-gap: 4px;
  min-height: 104px;
  padding: 16px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FAFAFA;
}
.works-flow-step > div {
  grid-row: 1/span 2;
  display: flex;
  width: 48px;
  height: 48px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 8px;
  background: #FFF5F2;
  color: #FE5A33;
}
.works-flow-step span {
  font-size: 16px;
  font-weight: 900;
  line-height: 1;
}
.works-flow-step h4 {
  color: #18181B;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.35;
}
.works-flow-step p {
  color: #71717A;
  font-size: 16px;
  line-height: 1.58;
}

.works-capability-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.works-capability-card,
.works-usecase-card {
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FAFAFA;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}
.works-capability-card:hover,
.works-usecase-card:hover {
  border-color: #FED7CC;
  box-shadow: 0 16px 34px rgba(24, 24, 27, 0.08);
  transform: translateY(-2px);
}
.works-capability-card > span,
.works-usecase-card > span {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  margin: 16px 0 14px;
  padding: 0 9px;
  border-radius: 6px;
  background: #FFF5F2;
  color: #FE5A33;
  font-size: 16px;
  font-weight: 900;
}
.works-capability-card h4,
.works-usecase-card h4 {
  color: #18181B;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.35;
}
.works-capability-card p,
.works-usecase-card p {
  margin-top: 10px;
  color: #71717A;
  font-size: 16px;
  line-height: 1.62;
}

.works-capability-card {
  min-height: 220px;
  padding: 22px;
}

.works-capability-icon,
.works-usecase-icon {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid #FED7CC;
  border-radius: 8px;
  background: #FFFFFF;
  color: #FE5A33;
}

.works-usecase-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.works-usecase-card {
  min-height: 212px;
  padding: 22px;
  background: #FFFFFF;
}

.arch-layer,
.info-panel,
.dataset-card {
  border-width: 1px;
  border-style: solid;
  border-radius: 8px;
}

.arch-layer {
  min-height: 148px;
  padding: 20px;
}

.info-panel {
  padding: 24px;
}

.dataset-card {
  display: flex;
  gap: 14px;
  min-height: 136px;
  padding: 20px;
  border-color: #E4E4E7;
  background: #FAFAFA;
}
.dataset-card h4 {
  color: #18181B;
  font-size: 16px;
  font-weight: 800;
}
.dataset-card span {
  display: block;
  margin-top: 2px;
  color: #A1A1AA;
  font-size: 16px;
}
.dataset-card p {
  margin-top: 10px;
  color: #71717A;
  font-size: 16px;
  line-height: 1.6;
}

.wiz-section-heading {
  max-width: 800px;
  margin-bottom: 24px;
}
.wiz-section-heading h3 {
  margin: 0 0 12px;
  color: #18181B;
  font-size: 28px;
  font-weight: 900;
  line-height: 1.2;
}
.wiz-section-heading p:not(.section-kicker) {
  color: #71717A;
  font-size: 16px;
  line-height: 1.72;
}

.wiz-workflow-section {
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(0, 0.92fr);
  gap: 28px;
  align-items: stretch;
}

.wiz-screen-visual {
  position: relative;
  overflow: hidden;
  min-height: 430px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #F4F4F5;
}
.wiz-screen-visual img {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 430px;
  object-fit: cover;
  object-position: top left;
}

.wiz-screen-caption {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 16px;
  display: flex;
  min-height: 44px;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(9, 9, 11, 0.78);
  color: #FFFFFF;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}
.wiz-screen-caption span {
  min-width: 0;
  overflow: hidden;
  font-size: 16px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wiz-workflow-copy {
  padding: 28px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
}
.wiz-workflow-copy h3 {
  margin: 0 0 12px;
  color: #18181B;
  font-size: 26px;
  font-weight: 900;
  line-height: 1.25;
}
.wiz-workflow-copy > p:not(.section-kicker) {
  color: #71717A;
  font-size: 16px;
  line-height: 1.72;
}

.wiz-flow-list {
  display: grid;
  gap: 10px;
  margin-top: 22px;
}

.wiz-flow-step {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  column-gap: 14px;
  row-gap: 4px;
  min-height: 104px;
  padding: 16px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FAFAFA;
}
.wiz-flow-step > div {
  grid-row: 1/span 2;
  display: flex;
  width: 48px;
  height: 48px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 8px;
  background: #FFF5F2;
  color: #FE5A33;
}
.wiz-flow-step span {
  font-size: 16px;
  font-weight: 900;
  line-height: 1;
}
.wiz-flow-step h4 {
  color: #18181B;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.35;
}
.wiz-flow-step p {
  color: #71717A;
  font-size: 16px;
  line-height: 1.58;
}

.wiz-capability-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.wiz-capability-card {
  min-height: 220px;
  padding: 22px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FAFAFA;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}
.wiz-capability-card:hover {
  border-color: #FED7CC;
  box-shadow: 0 16px 34px rgba(24, 24, 27, 0.08);
  transform: translateY(-2px);
}
.wiz-capability-card > span {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  margin: 16px 0 14px;
  padding: 0 9px;
  border-radius: 6px;
  background: #FFF5F2;
  color: #FE5A33;
  font-size: 16px;
  font-weight: 900;
}
.wiz-capability-card h4 {
  color: #18181B;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.35;
}
.wiz-capability-card p {
  margin-top: 10px;
  color: #71717A;
  font-size: 16px;
  line-height: 1.62;
}

.wiz-capability-icon {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid #FED7CC;
  border-radius: 8px;
  background: #FFFFFF;
  color: #FE5A33;
}

.wiz-case-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.wiz-case-card {
  display: flex;
  min-height: 472px;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}
.wiz-case-card:hover {
  border-color: #FED7CC;
  box-shadow: 0 18px 38px rgba(24, 24, 27, 0.1);
  transform: translateY(-2px);
}

.wiz-case-image {
  position: relative;
  aspect-ratio: 16/9;
  overflow: hidden;
  border-bottom: 1px solid #E4E4E7;
  background: #F4F4F5;
}
.wiz-case-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top left;
  transition: transform 0.35s ease;
}
.wiz-case-image span {
  position: absolute;
  left: 12px;
  top: 12px;
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #FE5A33;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 900;
}
.wiz-case-card:hover .wiz-case-image img {
  transform: scale(1.04);
}

.wiz-case-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 22px;
}
.wiz-case-body span {
  color: #FE5A33;
  font-size: 16px;
  font-weight: 900;
}
.wiz-case-body h4 {
  margin-top: 10px;
  color: #18181B;
  font-size: 20px;
  font-weight: 900;
  line-height: 1.35;
}
.wiz-case-body p {
  margin-top: 12px;
  color: #71717A;
  font-size: 16px;
  line-height: 1.66;
}

.dizest-section-heading {
  max-width: 780px;
  margin-bottom: 24px;
}
.dizest-section-heading h3 {
  margin: 0 0 12px;
  color: #18181B;
  font-size: 28px;
  font-weight: 900;
  line-height: 1.2;
}
.dizest-section-heading p:not(.section-kicker) {
  color: #71717A;
  font-size: 16px;
  line-height: 1.72;
}

.dizest-proof-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.dizest-proof-card {
  min-height: 242px;
  padding: 22px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FAFAFA;
}
.dizest-proof-card > span {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  margin: 16px 0 14px;
  padding: 0 9px;
  border-radius: 6px;
  background: #FFF5F2;
  color: #FE5A33;
  font-size: 16px;
  font-weight: 900;
}
.dizest-proof-card h4 {
  color: #18181B;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.35;
}
.dizest-proof-card p {
  margin-top: 10px;
  color: #71717A;
  font-size: 16px;
  line-height: 1.62;
}

.dizest-proof-icon {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid #FED7CC;
  border-radius: 8px;
  background: #FFFFFF;
  color: #FE5A33;
}

.dizest-research-panel {
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);
  gap: 24px;
  margin-bottom: 24px;
  padding: 28px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FAFAFA;
}

.dizest-research-copy h3 {
  margin: 0 0 12px;
  color: #18181B;
  font-size: 28px;
  font-weight: 900;
  line-height: 1.2;
}
.dizest-research-copy > p:not(.section-kicker) {
  color: #71717A;
  font-size: 16px;
  line-height: 1.72;
}

.dizest-paper-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 22px;
}
.dizest-paper-meta div {
  min-height: 82px;
  padding: 14px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
}
.dizest-paper-meta span {
  display: block;
  margin-bottom: 8px;
  color: #FE5A33;
  font-size: 16px;
  font-weight: 900;
}
.dizest-paper-meta strong {
  display: block;
  color: #18181B;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.35;
  word-break: keep-all;
  overflow-wrap: normal;
}

.dizest-source-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}
.dizest-source-actions a {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid #FED7CC;
  border-radius: 8px;
  background: #FFFFFF;
  color: #FE5A33;
  font-size: 16px;
  font-weight: 900;
  text-decoration: none;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.dizest-source-actions a:hover {
  border-color: #FE5A33;
  background: #FFF5F2;
}

.dizest-paper-point-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.dizest-paper-point {
  min-height: 194px;
  padding: 20px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
}
.dizest-paper-point > div {
  display: flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border: 1px solid #FED7CC;
  border-radius: 8px;
  color: #FE5A33;
}
.dizest-paper-point h4 {
  margin-top: 16px;
  color: #18181B;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.35;
}
.dizest-paper-point p {
  margin-top: 10px;
  color: #71717A;
  font-size: 16px;
  line-height: 1.62;
}

.dizest-publication-section {
  padding-top: 4px;
}

.dizest-publication-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.dizest-publication-card {
  min-height: 210px;
  padding: 20px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}
.dizest-publication-card:hover {
  border-color: #FED7CC;
  box-shadow: 0 16px 34px rgba(24, 24, 27, 0.08);
  transform: translateY(-2px);
}
.dizest-publication-card h4 {
  margin-top: 16px;
  color: #18181B;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.35;
}
.dizest-publication-card p {
  margin-top: 10px;
  color: #71717A;
  font-size: 16px;
  line-height: 1.62;
}

.dizest-publication-meta {
  display: flex;
  min-height: 28px;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.dizest-publication-meta span,
.dizest-publication-meta em {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  padding: 0 9px;
  border-radius: 6px;
  font-size: 16px;
  font-style: normal;
  font-weight: 900;
}
.dizest-publication-meta span {
  background: #FFF5F2;
  color: #FE5A33;
}
.dizest-publication-meta em {
  background: #F4F4F5;
  color: #52525B;
}

.dizest-workflow-section {
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(0, 0.92fr);
  gap: 28px;
  align-items: stretch;
}

.dizest-workflow-visual {
  position: relative;
  overflow: hidden;
  min-height: 420px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #F4F4F5;
}
.dizest-workflow-visual img {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 420px;
  object-fit: cover;
  object-position: top left;
}

.dizest-visual-caption {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 16px;
  display: flex;
  min-height: 44px;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(9, 9, 11, 0.78);
  color: #FFFFFF;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}
.dizest-visual-caption span {
  min-width: 0;
  overflow: hidden;
  font-size: 16px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dizest-workflow-copy {
  padding: 28px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
}
.dizest-workflow-copy h3 {
  margin: 0 0 12px;
  color: #18181B;
  font-size: 26px;
  font-weight: 900;
  line-height: 1.25;
}
.dizest-workflow-copy > p:not(.section-kicker) {
  color: #71717A;
  font-size: 16px;
  line-height: 1.72;
}

.dizest-flow-list {
  display: grid;
  gap: 10px;
  margin-top: 22px;
}

.dizest-flow-step {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  column-gap: 14px;
  row-gap: 4px;
  min-height: 104px;
  padding: 16px;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FAFAFA;
}
.dizest-flow-step > div {
  grid-row: 1/span 2;
  display: flex;
  width: 48px;
  height: 48px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 8px;
  background: #FFF5F2;
  color: #FE5A33;
}
.dizest-flow-step span {
  font-size: 16px;
  font-weight: 900;
  line-height: 1;
}
.dizest-flow-step h4 {
  color: #18181B;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.35;
}
.dizest-flow-step p {
  color: #71717A;
  font-size: 16px;
  line-height: 1.58;
}

.dizest-case-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.dizest-case-card {
  display: flex;
  min-height: 432px;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #E4E4E7;
  border-radius: 8px;
  background: #FFFFFF;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}
.dizest-case-card:hover {
  border-color: #FED7CC;
  box-shadow: 0 18px 38px rgba(24, 24, 27, 0.1);
  transform: translateY(-2px);
}

.dizest-case-image {
  position: relative;
  aspect-ratio: 16/7;
  overflow: hidden;
  border-bottom: 1px solid #E4E4E7;
  background: #F4F4F5;
}
.dizest-case-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top left;
  transition: transform 0.35s ease;
}
.dizest-case-image span {
  position: absolute;
  left: 12px;
  top: 12px;
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #FE5A33;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 900;
}
.dizest-case-card:hover .dizest-case-image img {
  transform: scale(1.04);
}

.dizest-case-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 20px;
}
.dizest-case-body span {
  color: #FE5A33;
  font-size: 16px;
  font-weight: 900;
}
.dizest-case-body h4 {
  margin-top: 10px;
  color: #18181B;
  font-size: 18px;
  font-weight: 900;
  line-height: 1.35;
}
.dizest-case-body p {
  margin-top: 10px;
  color: #71717A;
  font-size: 16px;
  line-height: 1.65;
}

@media (max-width: 1180px) {
  .direction-highlight-grid {
    grid-template-columns: 1fr;
  }
  .direction-flow-strip {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .solution-card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .works-capability-grid,
  .works-usecase-grid,
  .reviewops-contract-map,
  .wiz-capability-grid,
  .dizest-paper-point-grid,
  .dizest-publication-grid,
  .dizest-proof-grid,
  .dizest-case-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 1024px) {
  .direction-heading,
  .solution-list-heading,
  .detail-hero,
  .solution-detail-hero-panel,
  .solution-detail .detail-hero,
  .solution-detail .solution-detail-stack > :first-child,
  .solution-detail-stack > .detail-hero,
  .works-workflow-section,
  .reviewops-workflow-section,
  .reviewops-signal-board,
  .wiz-workflow-section,
  .dizest-research-panel,
  .dizest-workflow-section {
    grid-template-columns: 1fr;
  }
  .direction-heading-copy {
    align-self: start;
    max-width: none;
    padding-bottom: 0;
  }
  .detail-copy {
    max-width: none;
  }
}
@media (max-width: 768px) {
  .solution-tabs-wrap {
    position: sticky;
    top: 0;
    z-index: 80;
    box-shadow: 0 1px 0 rgba(228, 228, 231, 0.8), 0 8px 18px rgba(24, 24, 27, 0.04);
  }
  .solution-tabs {
    scroll-padding-inline: 16px;
  }
  .solution-detail-stack {
    gap: 18px;
  }
  .solution-detail-hero-panel,
  .solution-detail .detail-hero,
  .solution-detail .solution-detail-stack > :first-child,
  .solution-detail-stack > .detail-hero {
    padding: 24px;
  }
  .detail-title-row {
    align-items: flex-start;
    gap: 12px;
  }
  .detail-icon-tile {
    width: 48px;
    height: 48px;
  }
  .solution-tab {
    min-height: 38px;
    padding: 0 12px;
    font-size: 16px;
  }
  .direction-heading h2,
  .solution-list-heading h2 {
    font-size: 32px;
  }
  .direction-grid,
  .direction-flow-strip,
  .solution-card-grid,
  .process-note-grid,
  .works-capability-grid,
  .works-usecase-grid,
  .reviewops-contract-map,
  .reviewops-data-grid,
  .wiz-capability-grid,
  .wiz-case-grid,
  .dizest-paper-meta,
  .dizest-paper-point-grid,
  .dizest-publication-grid,
  .dizest-proof-grid,
  .dizest-case-grid {
    grid-template-columns: 1fr;
  }
  .works-section-heading h3,
  .works-workflow-copy h3,
  .reviewops-section-heading h3,
  .reviewops-workflow-copy h3,
  .wiz-section-heading h3,
  .wiz-workflow-copy h3,
  .dizest-section-heading h3,
  .dizest-research-copy h3,
  .dizest-workflow-copy h3 {
    font-size: 24px;
  }
  .detail-flow {
    grid-template-columns: 1fr;
  }
  .flow-line {
    width: 1px;
    height: 18px;
    margin: 0 auto;
  }
  .direction-card,
  .direction-panel,
  .detail-process-panel,
  .solution-card-body,
  .feature-card,
  .arch-layer,
  .info-panel,
  .dataset-card,
  .works-capability-card,
  .works-usecase-card,
  .works-workflow-copy,
  .works-flow-step,
  .reviewops-contract-card,
  .reviewops-data-card,
  .reviewops-workflow-copy,
  .reviewops-flow-step,
  .wiz-capability-card,
  .wiz-workflow-copy,
  .wiz-flow-step,
  .wiz-case-body,
  .dizest-research-panel,
  .dizest-paper-point,
  .dizest-publication-card,
  .dizest-proof-card,
  .dizest-workflow-copy,
  .dizest-flow-step,
  .dizest-case-body {
    padding: 18px;
  }
  .feature-card,
  .dataset-card {
    flex-direction: column;
  }
  .wiz-screen-visual,
  .wiz-screen-visual img,
  .works-hero-visual,
  .works-hero-visual img,
  .works-screen-visual,
  .works-screen-visual img,
  .reviewops-hero-visual,
  .reviewops-hero-visual img,
  .reviewops-screen-visual,
  .reviewops-screen-visual img,
  .dizest-workflow-visual,
  .dizest-workflow-visual img {
    min-height: 300px;
  }
  .works-flow-step,
  .reviewops-flow-step,
  .wiz-flow-step,
  .dizest-flow-step {
    grid-template-columns: 1fr;
  }
  .works-flow-step > div,
  .reviewops-flow-step > div,
  .wiz-flow-step > div,
  .dizest-flow-step > div {
    grid-row: auto;
  }
  .reviewops-hero-markers {
    display: none;
  }
  .reviewops-data-card {
    flex-direction: column;
  }
}`],
})
export class PageSolutionsComponent implements OnInit, OnDestroy {
    public tab: string = '';
    private routerSub: any;
    private validTabs: string[] = ['oedix', 'reviewops', 'dizest', 'wiz', 'works'];

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.tab = this.resolveTab(WizRoute.segment.tab || '');
        await this.service.render();

        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                const newTab = this.resolveTab(WizRoute.segment.tab || '');
                if (newTab !== this.tab) {
                    this.tab = newTab;
                    await this.service.render();
                }
            }
        });
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public subTabs = [
        { key: '', name: '개요', icon: 'icon-layout-grid' },
        { key: 'oedix', name: 'OEDIX', icon: 'icon-brain-circuit', logo: '/assets/solution/logos/season.png' },
        { key: 'reviewops', name: 'ReviewOps', icon: 'icon-clipboard-check', logo: '/assets/solution/logos/season.png' },
        { key: 'dizest', name: 'DIZEST', icon: 'icon-workflow', logo: '/assets/solution/logos/dizest.png' },
        { key: 'wiz', name: 'WIZ', icon: 'icon-code-2', logo: '/assets/solution/logos/wiz-symbol.png' },
        { key: 'works', name: 'Works', icon: 'icon-kanban', logo: '/assets/solution/logos/season.png' }
    ];

    public directionCards = [
        {
            icon: 'icon-database',
            title: '요청이 데이터가 됩니다',
            desc: '요청, 화면 캡처, 로그, Agent 결과, QA 판단을 다음 작업을 설계하는 운영 데이터로 축적합니다.'
        },
        {
            icon: 'icon-list-tree',
            title: '업무는 자동으로 나뉩니다',
            desc: '큰 요청은 stage, task queue, 우선순위, 검수 기준으로 분해되어 실행 가능한 작업 계약이 됩니다.'
        },
        {
            icon: 'icon-shield-check',
            title: '품질 기준이 먼저 정해집니다',
            desc: '방향, 금지 범위, 성공 기준을 harness로 고정해 AI가 만든 결과를 같은 기준으로 검수합니다.'
        },
        {
            icon: 'icon-forward',
            title: '다음 요구사항을 찾습니다',
            desc: '반복되는 불편, 재작업, 승인·반려 사유에서 다음 작업과 제품 개선 방향을 찾아냅니다.'
        }
    ];

    public directionHighlights = [
        {
            value: '100%',
            title: 'SW 개발 실행 자동화',
            desc: '구현, 수정, 검수 요청 처리는 Agent와 OEDIX 작업 제어 흐름으로 자동화합니다.'
        },
        {
            value: '방향',
            title: '사람의 역할 전환',
            desc: '사람은 코드를 직접 고치는 대신 무엇을 만들지, 어떤 품질로 볼지 결정합니다.'
        },
        {
            value: '품질',
            title: '데이터 기반 운영',
            desc: '리뷰와 QA 기록을 쌓아 다음 작업의 우선순위와 검수 기준을 더 빠르게 정합니다.'
        }
    ];

    public directionSteps = [
        { index: '01', title: '사람이 방향을 정합니다', desc: '목표, 우선순위, 품질 기준만 명확히 잡습니다.' },
        { index: '02', title: 'OEDIX가 작업을 나눕니다', desc: '큰 요청을 stage와 작은 실행 단위로 바꿉니다.' },
        { index: '03', title: 'Agent가 만들고 고칩니다', desc: '코드 수정과 화면 개선을 선택된 runtime이 처리합니다.' },
        { index: '04', title: 'OEDIX가 검수합니다', desc: '화면 증거, 로그, QA 기준으로 결과를 확인합니다.' },
        { index: '05', title: '다음 방향을 찾습니다', desc: '반복되는 문제에서 다음 요구사항을 뽑아냅니다.' }
    ];

    public dizestProofs = [
        {
            icon: 'icon-award',
            value: 'SoftwareX',
            ko: {
                title: '국제 저널 논문으로 정리된 플랫폼',
                desc: 'SoftwareX 33권에 게재된 DIZEST 논문은 AI와 데이터 분석을 위한 저코드 워크플로우 플랫폼 구조와 설계 원칙을 정리했습니다.'
            },
            en: {
                title: 'Platform published in SoftwareX',
                desc: 'The SoftwareX Volume 33 paper presents DIZEST as a low-code workflow platform for AI and data analysis.'
            }
        },
        {
            icon: 'icon-git-branch',
            value: 'GitHub',
            ko: {
                title: '검증 가능한 공개 워크플로우 코어',
                desc: 'GitHub에 공개된 DIZEST는 시각 워크플로우 편집기, 컴포넌트 아키텍처, DAG 실행 엔진, REST/SSE 실행 구조를 제공합니다.'
            },
            en: {
                title: 'Open workflow core',
                desc: 'The public GitHub repository documents a visual editor, component architecture, DAG execution engine, and REST/SSE runtime.'
            }
        },
        {
            icon: 'icon-scroll-text',
            value: '9 papers',
            ko: {
                title: '논문 실적으로 확장된 적용성',
                desc: 'GitHub의 Research & Publications 목록은 SoftwareX 저널 1건과 IEEE, 한국정보기술학회 학술 실적 8건을 DIZEST 적용 성과로 정리합니다.'
            },
            en: {
                title: 'Publication-backed applicability',
                desc: 'GitHub lists one SoftwareX journal paper and eight IEEE/KITS conference outcomes connected to DIZEST applications.'
            }
        },
        {
            icon: 'icon-factory',
            value: '6 cases',
            ko: {
                title: '산업 현장 중심의 적용 사례',
                desc: '해양 안전, 생명공학, 조선소 자동화, 반도체 장비, 농업 엣지, GPU 서버 모니터링까지 다양한 현장 문제에 적용했습니다.'
            },
            en: {
                title: 'Industry-focused use cases',
                desc: 'DIZEST has been applied to maritime safety, biotechnology, shipyards, semiconductor equipment, agricultural edge, and GPU monitoring.'
            }
        },
    ];

    public dizestPaperPoints = [
        {
            icon: 'icon-mouse-pointer-click',
            ko: {
                title: '코드 없는 워크플로우 구성',
                desc: '논문은 DIZEST를 비전문 사용자도 AI 애플리케이션과 데이터 분석 절차를 코드 없이 구성할 수 있는 LCDP로 설명합니다.'
            },
            en: {
                title: 'Code-free workflow construction',
                desc: 'The paper positions DIZEST as an LCDP that lets domain users compose AI applications and data analysis processes without coding.'
            }
        },
        {
            icon: 'icon-boxes',
            ko: {
                title: '재사용 가능한 노드 아키텍처',
                desc: '입력, 처리, 모델 실행, 시각화 단계를 재사용 가능한 노드와 컴포넌트로 분리해 개발 효율과 유지보수성을 높입니다.'
            },
            en: {
                title: 'Reusable node architecture',
                desc: 'Inputs, processing, model execution, and visualization are separated into reusable nodes and components for maintainable delivery.'
            }
        },
        {
            icon: 'icon-network',
            ko: {
                title: 'DAG 기반 의존성 실행',
                desc: 'GitHub 문서는 DAG resolver가 의존성을 분석하고 독립적인 워크플로우 분기를 병렬 실행하도록 설계되어 있음을 설명합니다.'
            },
            en: {
                title: 'DAG-based dependency execution',
                desc: 'The GitHub documentation describes a DAG resolver that analyzes dependencies and executes independent workflow branches in parallel.'
            }
        },
        {
            icon: 'icon-radio',
            ko: {
                title: 'API와 실시간 실행 연동',
                desc: 'REST API, Server-Sent Events, 이벤트 로그, 다중 포맷 렌더링을 통해 연구 워크플로우를 서비스 실행 환경과 연결합니다.'
            },
            en: {
                title: 'API and realtime runtime',
                desc: 'REST APIs, Server-Sent Events, event logs, and multi-format rendering connect research workflows to service runtimes.'
            }
        }
    ];

    public dizestPublications = [
        {
            year: '2026',
            venue: 'SoftwareX, Elsevier',
            ko: {
                title: 'DIZEST: A low-code platform for workflow-driven AI and data analysis',
                detail: 'DIZEST의 저코드 워크플로우 구조, 재사용 노드 아키텍처, AI/데이터 분석 적용성을 정리한 플랫폼 논문입니다.'
            },
            en: {
                title: 'DIZEST: A low-code platform for workflow-driven AI and data analysis',
                detail: 'A platform paper covering the low-code workflow structure, reusable node architecture, and AI/data analysis applicability.'
            }
        },
        {
            year: '2025',
            venue: 'IEEE International Conference',
            ko: {
                title: 'Korean Speech Recognition via RAG Keyword Correction',
                detail: 'RAG 기반 의도 인식 키워드 보정으로 한국어 음성 인식 결과를 개선하는 AI 워크플로우 적용 실적입니다.'
            },
            en: {
                title: 'Korean Speech Recognition via RAG Keyword Correction',
                detail: 'An AI workflow outcome for improving Korean speech recognition with RAG-based intent-aware keyword correction.'
            }
        },
        {
            year: '2025',
            venue: 'IEEE International Conference',
            ko: {
                title: 'Human Lymphocyte Viability Classification',
                detail: '디지털 인라인 홀로그래피와 머신러닝을 연결해 인체 림프구 생존율을 자동 분류한 바이오 분석 실적입니다.'
            },
            en: {
                title: 'Human Lymphocyte Viability Classification',
                detail: 'A biotechnology workflow for automated viability classification using digital in-line holography and machine learning.'
            }
        },
        {
            year: '2025',
            venue: 'IEEE International Conference',
            ko: {
                title: 'AI Kiosk Low-Code Methodology',
                detail: 'DIZEST 플랫폼을 활용해 AI 키오스크 서비스를 저코드 방식으로 개발한 사례 연구입니다.'
            },
            en: {
                title: 'AI Kiosk Low-Code Methodology',
                detail: 'A case study on developing AI kiosk services through a low-code methodology with the DIZEST platform.'
            }
        },
        {
            year: '2024',
            venue: 'KITS Conference',
            ko: {
                title: 'Industrial LLM Optimization',
                detail: '산업 현장 적용을 위해 LangChain과 RAG 기반 LLM 최적화 흐름을 DIZEST로 구성한 학술 실적입니다.'
            },
            en: {
                title: 'Industrial LLM Optimization',
                detail: 'A conference outcome applying DIZEST to LangChain and RAG-based LLM optimization for industrial deployment.'
            }
        },
        {
            year: '2023',
            venue: 'KITS Conference',
            ko: {
                title: 'Object Detection Low-Code Model',
                detail: '객체 탐지 딥러닝 모델을 DIZEST 저코드 흐름으로 구성해 농업 및 산업 검사 자동화 가능성을 검증했습니다.'
            },
            en: {
                title: 'Object Detection Low-Code Model',
                detail: 'A low-code object detection workflow demonstrating DIZEST for agricultural and industrial inspection automation.'
            }
        }
    ];

    public dizestFlowSteps = [
        {
            index: '01',
            icon: 'icon-mouse-pointer-click',
            ko: {
                title: '노드 기반 설계',
                desc: '데이터 입력, 전처리, 모델 실행, 시각화 컴포넌트를 캔버스에서 연결해 분석 흐름을 구성합니다.'
            },
            en: {
                title: 'Node-based design',
                desc: 'Connect data input, preprocessing, model execution, and visualization components on a canvas.'
            }
        },
        {
            index: '02',
            icon: 'icon-network',
            ko: {
                title: '의존성 기반 실행',
                desc: 'DAG 구조로 노드 간 입력과 출력을 해석해 실행 순서와 병렬 가능한 흐름을 자동으로 정리합니다.'
            },
            en: {
                title: 'Dependency-aware execution',
                desc: 'DAG-based resolution organizes execution order and parallelizable workflow branches.'
            }
        },
        {
            index: '03',
            icon: 'icon-chart-no-axes-combined',
            ko: {
                title: '결과 시각화',
                desc: '분석 결과를 표, 차트, 이미지, HTML 등 다양한 형태로 렌더링해 연구자와 현업 담당자가 함께 검토합니다.'
            },
            en: {
                title: 'Result visualization',
                desc: 'Render analysis outputs as tables, charts, images, and HTML for shared review.'
            }
        },
        {
            index: '04',
            icon: 'icon-radio',
            ko: {
                title: 'REST/SSE 실행 연계',
                desc: '동기식 REST API와 스트리밍 SSE 실행을 지원해 워크플로우 실행 상태, 로그, 결과를 서비스 화면과 외부 시스템에 연결합니다.'
            },
            en: {
                title: 'REST/SSE runtime integration',
                desc: 'Synchronous REST APIs and streaming SSE execution connect workflow status, logs, and results to service screens and external systems.'
            }
        }
    ];

    public dizestCases = [
        {
            index: '01',
            src: '/assets/solution/dizest/case-1.png',
            ko: {
                category: '해양 안전',
                title: '초분광 항공 영상 분석',
                detail: '초분광 항공 영상에서 해상 객체를 탐지하는 워크플로우를 구성해 해양 안전 연구와 SCI 논문 성과로 이어진 사례입니다. 대용량 영상 데이터 처리와 분류 모델 비교 과정을 흐름도로 재현했습니다.'
            },
            en: {
                category: 'Maritime safety',
                title: 'Hyperspectral image analysis',
                detail: 'A workflow for detecting maritime objects in hyperspectral aerial images, connected to research outcomes and SCI publications. The flow reproduces large-scale image processing and model comparison.'
            }
        },
        {
            index: '02',
            src: '/assets/solution/dizest/case-2.png',
            ko: {
                category: 'Bio technology',
                title: '렌즈프리 세포 분석',
                detail: '렌즈프리 세포 영상 분석 절차를 워크플로우로 정리해 생명공학 연구자가 머신러닝 기반 실험 설계와 분석을 더 쉽게 수행하도록 지원했습니다.'
            },
            en: {
                category: 'Bio technology',
                title: 'Lens-free cell analysis',
                detail: 'Lens-free cell image analysis was organized as a workflow so biotechnology researchers could run machine-learning-based experiments and analysis with less coding overhead.'
            }
        },
        {
            index: '03',
            src: '/assets/solution/dizest/case-3.png',
            ko: {
                category: 'Smart manufacturing',
                title: '조선소 자동화',
                detail: '조선소 현장의 경험적 지식과 머신러닝 모델을 연결해 공정 자동화, 품질 분석, 예측 유지보수 도구로 확장할 수 있는 흐름을 구성했습니다.'
            },
            en: {
                category: 'Smart manufacturing',
                title: 'Shipyard automation',
                detail: 'DIZEST connects field knowledge from shipyards with machine-learning models, enabling process automation, quality analysis, and predictive maintenance workflows.'
            }
        },
        {
            index: '04',
            src: '/assets/solution/dizest/case-4.png',
            ko: {
                category: 'Equipment monitoring',
                title: '반도체 장비 모니터링',
                detail: '플라즈마 장비에서 발생하는 고빈도 신호를 분석해 실시간 장비 상태 모니터링 도구를 개발한 사례입니다.'
            },
            en: {
                category: 'Equipment monitoring',
                title: 'Semiconductor equipment monitoring',
                detail: 'A real-time equipment monitoring workflow built to analyze high-frequency signals generated by plasma equipment in semiconductor environments.'
            }
        },
        {
            index: '05',
            src: '/assets/solution/dizest/case-5.png',
            ko: {
                category: 'AgriTech edge',
                title: '농업 엣지 컴퓨팅',
                detail: '통신과 장비 제약이 큰 농업 현장에서 엣지 디바이스로 실행 가능한 AIoT 분석 흐름을 검증한 사례입니다.'
            },
            en: {
                category: 'AgriTech edge',
                title: 'Agricultural edge computing',
                detail: 'DIZEST validates AIoT analysis flows that can run on edge devices in agricultural sites with limited network and equipment conditions.'
            }
        },
        {
            index: '06',
            src: '/assets/solution/dizest/case-6.png',
            ko: {
                category: 'Infra operation',
                title: 'GPU 서버 상태 모니터링',
                detail: 'GPU 서버 상태를 실시간으로 모니터링하고, 시각화 결과를 통해 장애 징후를 빠르게 확인하도록 구성한 운영 사례입니다.'
            },
            en: {
                category: 'Infra operation',
                title: 'GPU server monitoring',
                detail: 'An operational monitoring case that tracks GPU server status in real time and visualizes signals for faster failure prevention.'
            }
        }
    ];

    public wizFlowSteps = [
        {
            index: '01',
            icon: 'icon-panels-top-left',
            ko: {
                title: '화면과 서비스를 작은 단위로 분해',
                desc: '페이지, 컴포넌트, 레이아웃, API를 독립적인 개발 단위로 나누어 아이디어를 빠르게 화면에 올립니다.'
            },
            en: {
                title: 'Break screens into smaller units',
                desc: 'Pages, components, layouts, and APIs are separated into small development units so ideas can become screens quickly.'
            }
        },
        {
            index: '02',
            icon: 'icon-code-2',
            ko: {
                title: 'Angular 기반 위젯 개발',
                desc: '템플릿, TypeScript, SCSS를 앱 단위로 관리해 재사용성과 유지보수성을 높입니다.'
            },
            en: {
                title: 'Angular-based widget development',
                desc: 'Templates, TypeScript, and SCSS are managed by app unit to improve reuse and maintainability.'
            }
        },
        {
            index: '03',
            icon: 'icon-plug',
            ko: {
                title: '패키지와 외부 시스템 연동',
                desc: '패키지, 모델, 라우트, 외부 오픈소스 플랫폼을 연결해 웹 개발 이상의 솔루션을 구성합니다.'
            },
            en: {
                title: 'Packages and external integrations',
                desc: 'Packages, models, routes, and external open-source platforms can be connected to build complete solutions.'
            }
        },
        {
            index: '04',
            icon: 'icon-upload-cloud',
            ko: {
                title: '검토와 배포까지 한 흐름으로',
                desc: '프리뷰, Git 연동, 패키지 관리, 배포 흐름을 개발 화면 안에서 처리해 반복 작업을 줄입니다.'
            },
            en: {
                title: 'Review and deployment in one flow',
                desc: 'Preview, Git integration, package management, and deployment are handled within the development workspace.'
            }
        }
    ];

    public wizCapabilities = [
        {
            icon: 'icon-layout-template',
            value: 'Widget',
            ko: {
                title: '위젯형 앱 구조',
                desc: '화면을 재사용 가능한 위젯 단위로 구성해 서비스 화면과 관리 화면을 같은 방식으로 확장합니다.'
            },
            en: {
                title: 'Widget-style app structure',
                desc: 'Screens are built as reusable widgets so service and admin interfaces can scale in the same pattern.'
            }
        },
        {
            icon: 'icon-git-branch',
            value: 'Branch',
            ko: {
                title: '협업 가능한 작업 분기',
                desc: '자체 Git Branch 환경으로 여러 개발자가 기능을 나누어 만들고 검토할 수 있습니다.'
            },
            en: {
                title: 'Collaborative branches',
                desc: 'A built-in Git branch environment helps teams split, build, and review features together.'
            }
        },
        {
            icon: 'icon-eye',
            value: 'Preview',
            ko: {
                title: '빠른 화면 확인',
                desc: '프리뷰와 라우팅 기반 화면 확인으로 수정 결과를 즉시 검토하고 피드백 주기를 짧게 만듭니다.'
            },
            en: {
                title: 'Fast screen preview',
                desc: 'Preview and route-based checks make changes visible quickly and shorten feedback cycles.'
            }
        },
        {
            icon: 'icon-package',
            value: 'Package',
            ko: {
                title: '패키지 재사용',
                desc: '공통 컴포넌트와 모델을 패키지로 분리해 여러 프로젝트에서 같은 기능을 반복 구현하지 않도록 합니다.'
            },
            en: {
                title: 'Reusable packages',
                desc: 'Common components and models can be separated as packages to avoid rebuilding the same functions across projects.'
            }
        },
        {
            icon: 'icon-server',
            value: 'Full-stack',
            ko: {
                title: '프론트와 백엔드 연결',
                desc: 'Angular 화면, Python API, 모델, 라우트를 한 프로젝트 구조에서 연결해 웹 서비스 구현 범위를 넓힙니다.'
            },
            en: {
                title: 'Frontend and backend connected',
                desc: 'Angular screens, Python APIs, models, and routes are connected in one project structure.'
            }
        },
        {
            icon: 'icon-rocket',
            value: 'Delivery',
            ko: {
                title: '서비스화에 맞춘 생산성',
                desc: '관리자, 권한, 검색, 파일, 외부 연동처럼 실제 서비스에 필요한 기능을 더 빠르게 구성합니다.'
            },
            en: {
                title: 'Productivity for delivery',
                desc: 'Admin, permission, search, file, and external integration features can be composed faster for real services.'
            }
        }
    ];

    public wizCases = [
        {
            index: '01',
            src: '/assets/solution/wiz/webinar.png',
            ko: {
                category: 'External integration',
                title: '화상회의 서비스',
                detail: 'WIZ는 웹 개발뿐 아니라 외부 시스템과의 연동을 통해 다각도의 솔루션 구축을 지원합니다. BigBlueButton 기반 화상회의 플랫폼을 서비스 화면과 연결해 실제 운영 가능한 회의 서비스를 구현했습니다.'
            },
            en: {
                category: 'External integration',
                title: 'Video conferencing service',
                detail: 'WIZ supports full solution development through external-system integration. A BigBlueButton-based conferencing platform was connected to service screens and delivered as an operable meeting service.'
            }
        },
        {
            index: '02',
            src: '/assets/solution/wiz/kmbig.jpg',
            ko: {
                category: 'Data platform',
                title: '데이터 공유/활용 시스템',
                detail: '권한 부여, 데이터 공유, 검색처럼 복잡한 기능을 단순한 개발 흐름으로 구현한 사례입니다. 한의 빅데이터 통합 공유 시스템에 적용해 다수 사용자가 동시에 데이터를 검색하고 공유하는 구조를 실증했습니다.'
            },
            en: {
                category: 'Data platform',
                title: 'Data sharing system',
                detail: 'This case implemented complex functions such as permissions, data sharing, and search through a simpler development flow. It demonstrated concurrent data search and sharing in an integrated Korean medicine big-data platform.'
            }
        }
    ];

    public worksFlowSteps = [
        {
            index: '01',
            icon: 'icon-inbox',
            ko: {
                title: '요청과 할 일을 모읍니다',
                desc: '프로젝트, 운영 요청, 회의 후속 업무를 하나의 업무 카드로 접수해 담당자와 목표를 명확히 정리합니다.'
            },
            en: {
                title: 'Collect requests and work',
                desc: 'Project work, operation requests, and meeting follow-ups are captured as task cards with clear owners and goals.'
            }
        },
        {
            index: '02',
            icon: 'icon-kanban',
            ko: {
                title: '보드에서 상태를 움직입니다',
                desc: '대기, 진행, 검토, 완료처럼 팀의 방식에 맞춘 상태로 업무 흐름을 시각화하고 우선순위를 조정합니다.'
            },
            en: {
                title: 'Move status on the board',
                desc: 'Work is visualized through team-specific statuses such as backlog, in progress, review, and done.'
            }
        },
        {
            index: '03',
            icon: 'icon-message-circle',
            ko: {
                title: '카드 안에서 논의합니다',
                desc: '업무별 대화, TODO, 파일, 결정 사항을 카드에 함께 남겨 메신저와 메일에 흩어진 맥락을 줄입니다.'
            },
            en: {
                title: 'Discuss inside each card',
                desc: 'Conversations, TODOs, files, and decisions stay with the task card to reduce scattered context across chat and email.'
            }
        },
        {
            index: '04',
            icon: 'icon-book-open',
            ko: {
                title: '자료와 지식으로 남깁니다',
                desc: '완료된 업무의 산출물과 운영 기준을 드라이브와 위키에 연결해 다음 프로젝트가 바로 이어받을 수 있게 합니다.'
            },
            en: {
                title: 'Preserve files and knowledge',
                desc: 'Deliverables and operating rules are connected to Drive and Wiki so the next project can reuse them quickly.'
            }
        }
    ];

    public worksCapabilities = [
        {
            icon: 'icon-layout-dashboard',
            value: 'Project',
            ko: {
                title: '프로젝트별 업무 공간',
                desc: '팀, 고객사, 과제 단위로 업무 공간을 나누고 보드, 멤버, 파일, 문서를 같은 맥락으로 묶습니다.'
            },
            en: {
                title: 'Project workspaces',
                desc: 'Workspaces can be organized by team, client, or assignment, keeping boards, members, files, and documents in one context.'
            }
        },
        {
            icon: 'icon-kanban',
            value: 'Board',
            ko: {
                title: '진행 상태가 보이는 이슈보드',
                desc: '카드 기반 보드로 담당자, 진행률, 우선순위, 마감일을 빠르게 확인하고 업무 병목을 발견합니다.'
            },
            en: {
                title: 'Visible issue board',
                desc: 'Card-based boards show assignees, progress, priorities, and due dates so teams can find bottlenecks early.'
            }
        },
        {
            icon: 'icon-message-circle',
            value: 'Chat',
            ko: {
                title: '업무 카드 중심 실시간 대화',
                desc: '작업 단위별 메시지와 댓글을 남겨 누가 어떤 결정을 했는지 업무 이력 안에서 바로 확인합니다.'
            },
            en: {
                title: 'Task-centered realtime chat',
                desc: 'Messages and comments are stored by task so teams can immediately see who made which decisions.'
            }
        },
        {
            icon: 'icon-hard-drive',
            value: 'Drive',
            ko: {
                title: '산출물을 모으는 드라이브',
                desc: '업무에 필요한 문서, 이미지, 참고 파일을 카드와 프로젝트에 연결해 최신 자료를 찾는 시간을 줄입니다.'
            },
            en: {
                title: 'Drive for deliverables',
                desc: 'Documents, images, and references are attached to cards and projects so teams spend less time finding the latest file.'
            }
        },
        {
            icon: 'icon-book-open',
            value: 'Wiki',
            ko: {
                title: '프로젝트 지식 위키',
                desc: '운영 규칙, 회의 기록, 작업 가이드, 인수인계 문서를 독립된 위키로 정리해 팀 지식을 축적합니다.'
            },
            en: {
                title: 'Project knowledge wiki',
                desc: 'Operating rules, meeting notes, guides, and handover documents are organized as a dedicated project wiki.'
            }
        },
        {
            icon: 'icon-laptop',
            value: 'Responsive',
            ko: {
                title: '데스크톱과 모바일 대응',
                desc: '현장과 사무실 어디서든 업무 목록, 카드 상세, 메시지를 확인할 수 있도록 반응형 화면을 지원합니다.'
            },
            en: {
                title: 'Desktop and mobile ready',
                desc: 'Responsive screens let teams check lists, task details, and messages from the office or the field.'
            }
        }
    ];

    public worksUseCases = [
        {
            icon: 'icon-users',
            ko: {
                category: 'Project room',
                title: '프로젝트 실행 현황 공유',
                detail: '개발, 디자인, 운영 담당자가 같은 보드를 보며 이번 주 해야 할 일, 지연 업무, 검토 대상을 한눈에 맞춥니다.'
            },
            en: {
                category: 'Project room',
                title: 'Shared project execution',
                detail: 'Development, design, and operations teams align weekly work, delayed items, and review targets on one board.'
            }
        },
        {
            icon: 'icon-shield-check',
            ko: {
                category: 'Issue response',
                title: '고객 요청과 이슈 대응',
                detail: '고객 문의나 내부 개선 요청을 카드로 전환하고 진행 상황, 대화, 첨부 자료를 같은 기록으로 관리합니다.'
            },
            en: {
                category: 'Issue response',
                title: 'Customer requests and issues',
                detail: 'Customer inquiries and internal improvement requests become cards with status, conversations, and attachments in one record.'
            }
        },
        {
            icon: 'icon-scroll-text',
            ko: {
                category: 'Knowledge handover',
                title: '반복 업무의 지식화',
                detail: '완료된 카드의 결정 사항과 파일을 위키로 연결해 같은 질문과 자료 요청이 반복되는 상황을 줄입니다.'
            },
            en: {
                category: 'Knowledge handover',
                title: 'Knowledge from repeated work',
                detail: 'Decisions and files from completed cards are linked to Wiki pages to reduce repeated questions and file requests.'
            }
        }
    ];

    public reviewopsFlowSteps = [
        {
            index: '01',
            icon: 'icon-file-input',
            ko: {
                title: '요청을 작업 계약으로 고정',
                desc: '리뷰 제목, 원문 요구, 화면 캡처, 링크, 환경 정보를 한 요청으로 묶습니다.'
            },
            en: {
                title: 'Lock the request as a work contract',
                desc: 'Review title, original request, screenshots, links, and environment data are grouped into one request.'
            }
        },
        {
            index: '02',
            icon: 'icon-terminal',
            ko: {
                title: 'Agent 실행 결과를 추적',
                desc: 'Codex 상태, 변경 파일, 실행 로그, 작업 시간을 리뷰 흐름에 남깁니다.'
            },
            en: {
                title: 'Trace agent execution results',
                desc: 'Codex status, changed files, execution logs, and elapsed time are preserved in the review flow.'
            }
        },
        {
            index: '03',
            icon: 'icon-shield-check',
            ko: {
                title: 'QA Gate에서 판단',
                desc: '승인, 보류, 재작업 사유를 남겨 같은 기준으로 결과를 다시 검수합니다.'
            },
            en: {
                title: 'Decide at the QA gate',
                desc: 'Approval, hold, and rework reasons are recorded so results can be reviewed against consistent criteria.'
            }
        },
        {
            index: '04',
            icon: 'icon-forward',
            ko: {
                title: '다음 방향을 추출',
                desc: '반복되는 불편, 실패 로그, 보정 요청을 다음 요구사항과 검수 기준으로 전환합니다.'
            },
            en: {
                title: 'Extract the next direction',
                desc: 'Repeated friction, failure logs, and correction requests become next requirements and review criteria.'
            }
        }
    ];

    public reviewopsContracts = [
        {
            value: 'Request',
            icon: 'icon-scroll-text',
            ko: {
                title: '요청 원문',
                desc: '무엇을 바꿔야 하는지, 어떤 맥락에서 발생했는지 고정합니다.'
            },
            en: {
                title: 'Original request',
                desc: 'What needs to change and where it happened are fixed at the review level.'
            }
        },
        {
            value: 'Evidence',
            icon: 'icon-camera',
            ko: {
                title: '화면 증거',
                desc: '스크린샷, DOM 상태, 네트워크·콘솔 로그, 사용자 입력을 보존합니다.'
            },
            en: {
                title: 'Screen evidence',
                desc: 'Screenshots, DOM state, network and console logs, and user input are preserved as reproduction evidence.'
            }
        },
        {
            value: 'Agent',
            icon: 'icon-bot',
            ko: {
                title: '작업 이력',
                desc: 'Agent가 바꾼 파일과 실행 명령을 추적 가능한 결과로 남깁니다.'
            },
            en: {
                title: 'Work history',
                desc: 'Which files the agent changed and which commands it ran are retained as traceable results.'
            }
        },
        {
            value: 'QA Gate',
            icon: 'icon-clipboard-check',
            ko: {
                title: '검수 판단',
                desc: '승인, 보정, 재작업, 보류 사유를 다음 품질 기준으로 축적합니다.'
            },
            en: {
                title: 'QA decision',
                desc: 'Approve, correction, rework, and hold reasons accumulate as quality criteria for future work.'
            }
        }
    ];

    public reviewopsSignals = [
        {
            value: 'Before',
            ko: {
                title: '채팅형 개발 요청',
                desc: '요청과 결과가 흩어져 사람이 다시 확인하고 재작업을 지시해야 했습니다.'
            },
            en: {
                title: 'Chat-based development requests',
                desc: 'Requests and results were scattered, so people had to re-check screens and ask for rework.'
            }
        },
        {
            value: 'ReviewOps',
            ko: {
                title: '증거 기반 QA 운영',
                desc: '요청, 화면 증거, Agent 실행, QA 판단을 같은 흐름에 묶습니다.'
            },
            en: {
                title: 'Evidence-based QA operations',
                desc: 'Requests, screen evidence, agent execution, and QA decisions are tied into one quality flow.'
            }
        },
        {
            value: 'After',
            ko: {
                title: '방향 요구사항 발견',
                desc: '반복되는 승인·반려 사유에서 다음 방향과 검수 기준을 찾습니다.'
            },
            en: {
                title: 'Direction requirement discovery',
                desc: 'Repeated approval and rejection reasons reveal the next product direction and QA criteria.'
            }
        }
    ];

    public reviewopsDataCards = [
        {
            icon: 'icon-file-text',
            ko: {
                title: '요청 맥락',
                desc: '원문 요구, 화면 위치, 첨부, 프로젝트 규칙을 작업 입력으로 묶습니다.'
            },
            en: {
                title: 'Request context',
                desc: 'Original requests, screen location, attachments, and project rules are organized as work inputs.'
            }
        },
        {
            icon: 'icon-list-tree',
            ko: {
                title: '분해 패턴',
                desc: '작업 크기, 선후관계, 병렬·순차 기준을 분할 기준으로 남깁니다.'
            },
            en: {
                title: 'Slicing pattern',
                desc: 'Task size, dependencies, and parallel or sequential criteria become the next slicing rules.'
            }
        },
        {
            icon: 'icon-shield',
            ko: {
                title: '검수 패턴',
                desc: '통과 기준, 누락 유형, 재작업 조건을 QA 판단 근거로 축적합니다.'
            },
            en: {
                title: 'Review pattern',
                desc: 'Pass criteria, omission types, and rework conditions accumulate as QA Gate evidence.'
            }
        },
        {
            icon: 'icon-database',
            ko: {
                title: '품질 데이터',
                desc: '좋은 산출물의 구조, 근거, 표현 방식을 Agent 작업 기준으로 전환합니다.'
            },
            en: {
                title: 'Quality data',
                desc: 'The structure, evidence, and expression of good outputs become criteria for future agent work.'
            }
        }
    ];

    public solutions = [
        {
            key: 'oedix', name: 'OEDIX', icon: 'icon-brain-circuit',
            logo: '/assets/solution/logos/season.png',
            tagline: 'solution.oedix.title',
            subtitle: '차세대 Agent Orchestration 플랫폼',
            desc: 'solution.oedix.detail',
            direction: '현재 개발 중인 OEDIX는 사람의 큰 방향을 기반으로 복잡한 업무를 작게 나누고, Agent 실행과 검수, 다음 작업 생성을 하나의 공정으로 연결하는 차세대 솔루션입니다.',
            image: '/assets/solution/oedix-orchestrator.svg',
            screenLabel: '업무 공정, Task Queue, Harness, Agent Runtime을 연결하는 OEDIX 구조',
            process: {
                title: 'OEDIX 작동 흐름',
                desc: '큰 요청을 공정 계획, 작업 대기열, 실행 계약, 검수 기준으로 바꿔 Agent가 안정적으로 처리하도록 설계합니다.',
                nodes: [
                    { icon: 'icon-list-tree', label: '공정 계획' },
                    { icon: 'icon-brain-circuit', label: 'Agent 실행' },
                    { icon: 'icon-shield-check', label: 'QA/후속 작업' }
                ],
                notes: [
                    { title: '계획', desc: '업무 목표, 범위, 의존성, 산출물 기준을 stage와 task로 분해' },
                    { title: '실행', desc: 'Codex, Claude Code, Hermes, 내부 LLM을 동일한 작업 계약으로 호출' },
                    { title: '검증', desc: 'Harness, QA Gate, replay 근거를 실행 결과와 연결해 다음 작업 생성' }
                ]
            },
            features: [
                { title: 'solution.oedix.innovation.title1', desc: 'solution.oedix.innovation.detail1', icon: 'icon-list-tree' },
                { title: 'solution.oedix.innovation.title2', desc: 'solution.oedix.innovation.detail2', icon: 'icon-shield-check' },
                { title: 'solution.oedix.innovation.title3', desc: 'solution.oedix.innovation.detail3', icon: 'icon-git-branch' },
                { title: 'solution.oedix.innovation.title4', desc: 'solution.oedix.innovation.detail4', icon: 'icon-terminal' }
            ],
            tags: ['개발 예정', 'Agent Orchestration', 'Task Queue', 'Harness', 'QA Gate', 'Runtime Adapter', 'Gold Dataset']
        },
        {
            key: 'reviewops', name: 'ReviewOps', icon: 'icon-clipboard-check',
            logo: '/assets/solution/logos/season.png',
            tagline: 'solution.reviewops.title',
            subtitle: '증거 기반 개발 QA 운영',
            desc: 'solution.reviewops.detail',
            direction: '사람이 방향과 품질 기준을 정하고, Agent 작업 결과는 화면 증거와 QA 판단을 기준으로 검수되는 운영 흐름을 만듭니다.',
            image: '/assets/solution/reviewops-screen.png',
            screenLabel: '리뷰 요청, 화면 증거, Agent 작업, QA 상태를 함께 추적',
            process: {
                title: 'ReviewOps 작동 흐름',
                desc: '리뷰 요청의 화면 증거와 로그를 수집하고, Agent 작업 결과를 검수 이력으로 축적합니다.',
                nodes: [
                    { icon: 'icon-camera', label: '증거 수집' },
                    { icon: 'icon-bot', label: '작업 추적' },
                    { icon: 'icon-clipboard-check', label: 'QA 판정' }
                ],
                notes: [
                    { title: '요청', desc: '리뷰 내용, 스크린샷, 네트워크/콘솔 로그를 한 요청으로 묶음' },
                    { title: '실행', desc: 'Codex 작업 상태, 변경 파일, 빌드 결과를 리뷰 흐름에 기록' },
                    { title: '판정', desc: '승인, 보정, 재작업 사유를 다음 개선 기준으로 저장' }
                ]
            },
            features: [
                { title: 'solution.reviewops.innovation.title1', desc: 'solution.reviewops.innovation.detail1', icon: 'icon-camera' },
                { title: 'solution.reviewops.innovation.title2', desc: 'solution.reviewops.innovation.detail2', icon: 'icon-bot' },
                { title: 'solution.reviewops.innovation.title3', desc: 'solution.reviewops.innovation.detail3', icon: 'icon-shield-check' },
                { title: 'solution.reviewops.innovation.title4', desc: 'solution.reviewops.innovation.detail4', icon: 'icon-database' }
            ],
            tags: ['리뷰 운영', 'Codex 작업', 'QA 판단', '화면 증거', '로그', '기준 데이터']
        },
        {
            key: 'dizest', name: 'DIZEST', icon: 'icon-workflow',
            logo: '/assets/solution/logos/dizest.png',
            tagline: 'solution.dizest.title',
            subtitle: 'AI/데이터 분석 저코드 워크플로우',
            desc: 'solution.dizest.detail',
            direction: '현업 사용자의 도메인 지식과 AI/데이터 분석 기술을 연결해 연구, 제조, 인프라 운영 과정을 재현 가능한 워크플로우로 전환합니다.',
            image: '/assets/solution/dizest-screen.gif',
            screenLabel: '연구 절차를 흐름도 기반으로 설계하고 실행',
            process: {
                title: 'DIZEST 작동 흐름',
                desc: '분석 절차를 노드와 의존성으로 설계하고, DAG 실행과 결과 시각화로 반복 가능한 워크플로우를 만듭니다.',
                nodes: [
                    { icon: 'icon-mouse-pointer-click', label: '노드 설계' },
                    { icon: 'icon-network', label: 'DAG 실행' },
                    { icon: 'icon-chart-no-axes-combined', label: '결과 시각화' }
                ],
                notes: [
                    { title: '입력', desc: '데이터, 전처리, 모델 실행, 시각화 컴포넌트를 캔버스에 배치' },
                    { title: '실행', desc: '노드 간 의존성과 병렬 가능한 분기를 해석해 순서대로 실행' },
                    { title: '검토', desc: '표, 차트, 이미지, 이벤트 로그로 분석 결과를 확인하고 재실행' }
                ]
            },
            features: [
                { title: 'solution.dizest.innovation.title1', desc: 'solution.dizest.innovation.detail1', icon: 'icon-eye' },
                { title: 'solution.dizest.innovation.title2', desc: 'solution.dizest.innovation.detail2', icon: 'icon-zap' },
                { title: 'solution.dizest.innovation.title3', desc: 'solution.dizest.innovation.detail3', icon: 'icon-shield' },
                { title: 'solution.dizest.innovation.title4', desc: 'solution.dizest.innovation.detail4', icon: 'icon-microscope' }
            ],
            tags: ['SoftwareX 2026', 'Low-code', 'Workflow Engine', 'DAG 실행', 'REST/SSE', '논문 실적', '산업 적용']
        },
        {
            key: 'wiz', name: 'WIZ', icon: 'icon-code-2',
            logo: '/assets/solution/logos/wiz-symbol.png',
            tagline: 'solution.wiz.title',
            subtitle: '위젯 기반 웹 개발 프레임워크',
            desc: 'solution.wiz.detail',
            direction: '아이디어를 빠르게 화면과 서비스로 구현할 수 있도록 개발 단위를 작게 나누고, 외부 시스템 연동과 배포까지 이어지는 구조를 제공합니다.',
            image: '/assets/solution/wiz-screen.gif',
            screenLabel: 'WIZ 개발 화면에서 위젯, 패키지, 프리뷰를 함께 구성',
            process: {
                title: 'WIZ 작동 흐름',
                desc: '웹 서비스를 페이지, 컴포넌트, API 단위로 나누고 프리뷰와 패키지, 배포 흐름으로 구현 속도를 높입니다.',
                nodes: [
                    { icon: 'icon-panels-top-left', label: '화면 단위화' },
                    { icon: 'icon-plug', label: 'API 연결' },
                    { icon: 'icon-upload-cloud', label: '프리뷰 배포' }
                ],
                notes: [
                    { title: '구성', desc: '페이지, 컴포넌트, 레이아웃, API를 작은 개발 단위로 분리' },
                    { title: '개발', desc: 'Angular UI, TypeScript, Python API, 패키지를 한 프로젝트에서 연결' },
                    { title: '검토', desc: 'Preview, Git Branch, Package, Deployment 흐름으로 서비스화' }
                ]
            },
            features: [
                { title: 'solution.wiz.innovation.title1', desc: 'solution.wiz.innovation.detail1', icon: 'icon-component' },
                { title: 'solution.wiz.innovation.title2', desc: 'solution.wiz.innovation.detail2', icon: 'icon-git-merge' },
                { title: 'solution.wiz.innovation.title3', desc: 'solution.wiz.innovation.detail3', icon: 'icon-rocket' },
                { title: 'solution.wiz.innovation.title4', desc: 'solution.wiz.innovation.detail4', icon: 'icon-puzzle' }
            ],
            tags: ['Angular', 'TypeScript', 'Python API', 'Widget', 'Package', 'Git Branch', 'Preview', 'Deployment']
        },
        {
            key: 'works', name: 'Works', icon: 'icon-kanban',
            logo: '/assets/solution/logos/season.png',
            tagline: 'solution.works.title',
            subtitle: '프로젝트 관리와 지식 공유를 연결하는 협업 플랫폼',
            desc: 'solution.works.detail',
            direction: '프로젝트 보드, 업무 카드, 실시간 대화, 드라이브, 위키를 한 화면 흐름으로 연결해 팀이 같은 맥락에서 업무를 이어가도록 합니다.',
            image: '/assets/solution/works-screen.jpg',
            screenLabel: '데스크톱, 태블릿, 모바일에서 이어지는 Works 협업 화면',
            features: [
                { title: 'solution.works.innovation.title1', desc: 'solution.works.innovation.detail1', icon: 'icon-layout-dashboard' },
                { title: 'solution.works.innovation.title2', desc: 'solution.works.innovation.detail2', icon: 'icon-message-circle' },
                { title: 'solution.works.innovation.title3', desc: 'solution.works.innovation.detail3', icon: 'icon-hard-drive' },
                { title: 'solution.works.innovation.title4', desc: 'solution.works.innovation.detail4', icon: 'icon-book-open' }
            ],
            tags: ['프로젝트 보드', '업무 카드', '실시간 채팅', '드라이브', '위키', '모바일 대응', '업무 이력', '자료 공유']
        }
    ];

    get currentSolution() {
        return this.solutions.find(s => s.key === this.tab) || null;
    }

    get isOverview(): boolean {
        return !this.tab;
    }

    public isTabActive(key: string): boolean {
        return key ? this.tab === key : this.isOverview;
    }

    public selectTab(key: string) {
        this.service.href(key ? '/solutions/' + key : '/solutions');
    }

    public localize(item: any): any {
        const lang = this.service && this.service.lang ? this.service.lang.get() : 'ko';
        return item[lang] || item.ko || item.en || item;
    }

    private resolveTab(tab: string): string {
        return this.validTabs.indexOf(tab) >= 0 ? tab : '';
    }

}

export default PageSolutionsComponent;